import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import Sortable from 'sortablejs';
import UEditor from "@/components/UEditor/index.vue";
import QuestionForm from "../components/QuestionForm.vue";
import TransferDialog from "../components/TransferDialog.vue";
import LocalTopTips from "../components/LocalTopTips.vue";
import SelectClassify from "@/components/SelectClassify/index.vue";
import { QUESTION_TYPE_MAP } from "../constant";
import { AppModule } from "@/store/modules/app";
import { getQuestionDetail, saveQuestionDetail, transferQuestion } from "@/api/question";
import { checkSession } from "@/api/commom";
import eventEmitter from "@/utils/eventEmitter";
let MaterialQuestionEdit = class MaterialQuestionEdit extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.questionContentDefault = "";
        this.topicTypeName = "";
        this.showDialog = false;
        this.questionBankParentId = "0";
        this.treeData = [];
        this.dialogLoading = false;
        this.formData = {
            questionLibraryId: '-1',
            content: '',
            describ: '',
            materialList: []
        };
        this.drag = false;
        this.currentSelectedItem = {};
        this.questionMap = QUESTION_TYPE_MAP.slice(0, -1);
        this.hasSubmit = false;
        this.containerHeight = 0;
        this.contentMap = {};
        this.mainContainerDom = null;
        this.childContainerDom = null;
        this.childFormTaskQueue = [];
        this.hasLockChildQuestionClick = false;
        // questionSort = 0
        this.sortable = null;
        this.isJoinPaper = false;
        this.isReference = false;
        this.paperId = "";
        this.aliveInterval = null;
        this.shouldDialogShow = true;
    }
    get isEdit() {
        const query = this.$route.query;
        return query.is_edit != null ? Number(query.is_edit) : Number(sessionStorage.getItem("isEdit"));
    }
    get questionId() {
        return sessionStorage.getItem("questionId") || this.$route.query.question_id || '';
    }
    get type() {
        const query = this.$route.query;
        return query.type != null ? Number(query.type) : Number(sessionStorage.getItem("type"));
    }
    get dragOptions() {
        var _that = this;
        return {
            dragClass: "dragClass",
            ghostClass: "ghostClass",
            animation: 300,
            onStart: () => {
                this.questionList.classList.remove("allow-hover");
            },
            onEnd: (evt) => {
                var questionList = _that.formData.materialList;
                questionList = this.swapArr(questionList, evt.oldIndex, evt.newIndex);
                // this.formData.materialList = questionList
                this.questionList.classList.add("allow-hover");
            }
        };
    }
    // get updateWeightMap() {
    //   var e = this.formData.materialList || []
    //     , t = e.reduce((function (e, t) {
    //       return t.isNewAdd || (e[t.id] = t.weight),
    //         e
    //     }
    //     ), {});
    //   return t
    // }
    get disabled() {
        return !!this.isJoinPaper;
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    get imgIcon() {
        return require('@/assets/icon_pic.png');
    }
    handleMaterialListChange(questionList) {
        const t = questionList.length - 1 || 0;
        questionList.forEach((ques, index) => { ques.weight = t - index; });
    }
    handleDisabledChange(state) {
        this.$nextTick(() => {
            this.sortable && this.sortable.option('disabled', state);
        });
    }
    // @Watch('showDialog')
    // handleShowDialogChange(state: boolean) {
    //   state && this.handleGetLibraryData()
    // }
    created() {
        const query = this.$route.query;
        sessionStorage.setItem("type", query.type);
        sessionStorage.setItem("isEdit", query.is_edit);
        sessionStorage.setItem("questionId", query.question_id);
        this.paperId = query.paper_id || '';
        // this.formData.questionLibraryId = decodeURI(this.getQueryString("questionBankId")) || ""
        window.UEDITOR_CONFIG.initialFrameHeight = 225;
        window.UEDITOR_CONFIG.initialFrameWidth = 680;
        this.$nextTick(() => {
            this.handleGetQuesLibInfo();
        });
        this.aliveInterval = setInterval(() => {
            checkSession();
        }, 30 * 1000);
        if (this.interceptRoute) {
            eventEmitter.on('routerRapture', () => this.shouldDialogShow ? Promise.reject() : Promise.resolve());
        }
    }
    mounted() {
        // window.getSaveFlag = function () {
        //   return true
        // }
        // this.gooseClass && window.addEventListener("message", this.getInfo, true)
        this.initDomHeight();
        window.addEventListener("resize", this.initDomHeight);
        this.$nextTick(() => {
            var t = this.questionList;
            this.sortable = Sortable.create(t, this.dragOptions);
        });
    }
    beforeDestroy() {
        clearInterval(this.aliveInterval);
    }
    destroyed() {
        // window.getSaveFlag = function () {
        //   return false
        // }
        window.removeEventListener("resize", this.initDomHeight);
    }
    // getInfo(e) {
    //   var t = e.data;
    //   switch (t.cmd) {
    //     case "cancelEditQuestion":
    //       console.log("cancelEditQuestion___", t),
    //         this.handleCancel();
    //       break;
    //     case "saveQuestion":
    //       console.log("saveQuestion___", t),
    //         this.handleSubmit(true);
    //       break
    //   }
    // }
    swapArr(arr, oldIndex, newIndex) {
        arr.splice(oldIndex, 1, arr.splice(newIndex, 1, arr[oldIndex])[0]);
        return arr;
    }
    sleep(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }
    initData(question) {
        if (!this.isEdit)
            return;
        const subQuestionList = question.subQuestionList;
        this.formData.id = question.id;
        this.formData.describ = question.simpleContent || '';
        this.formData.content = question.content;
        // this.questionSort = question.sort
        this.setMaterialEditor(question.content);
        this.isReference = question.referenceCount > 0;
        this.isJoinPaper = question.referenceCount > 0;
        this.formData.materialList = subQuestionList.map((subQuestion) => {
            this.$set(this.contentMap, subQuestion.id, this.insulateImg(subQuestion.content, subQuestion.simpleContent));
            const type = subQuestion.type;
            const editParams = {
                id: subQuestion.id,
                content: subQuestion.content,
                analysis: subQuestion.analysis || '',
                describ: subQuestion.simpleContent
            };
            if (type === 0 || type === 1 || type === 5) {
                editParams.optionList = subQuestion.optionList.map(opt => ({
                    id: opt.id,
                    content: opt.content,
                    describ: opt.simpleContent,
                    type: opt.correct
                }));
            }
            else if (type === 2) {
                editParams.answer = subQuestion.optionList[0].content;
            }
            else if (type === 3) {
                editParams.answer = subQuestion.optionList[0].correct;
            }
            if (type === 4) {
                editParams.answer = subQuestion.optionList.map(opt => opt.content);
                editParams.disorderMatch = subQuestion.disorderMatch;
            }
            return {
                id: subQuestion.id,
                type,
                editParams,
                show: false,
                isEdit: true,
                validResult: true,
            };
        });
    }
    initDomHeight() {
        const clientHeight = document.documentElement.clientHeight;
        const containerEl = this.container;
        const top = containerEl.getBoundingClientRect().top || 0;
        const bottomBarHeight = document.querySelector('.add-bottom').clientHeight || 0;
        const headerHeight = this.header.clientHeight || 0;
        const offset = 20;
        const height = clientHeight - top - offset - bottomBarHeight;
        containerEl.style.cssText = `height: ${height}px`;
        this.formWrapper.style.cssText = `height: ${height - headerHeight}px`;
        this.mainContainerDom = this.mainContainer;
        this.childContainerDom = this.childContainer;
        this.updateContainerHeight();
    }
    getRandomHash() {
        return `${Math.random().toString(16).slice(2)}${Date.now()}`;
    }
    getQuestionName(id) {
        const type = QUESTION_TYPE_MAP.find(t => t.id === id);
        return type && type.text || "";
    }
    getUEContent(content, _, describ) {
        this.formData.content = content;
        this.formData.describ = describ;
    }
    setMaterialEditor(content) {
        this.material && this.material.setContent(content);
    }
    async handleAddQuestion(type) {
        const isChildQuestionValid = await this.handleCheckCurrentChildQuestion();
        if (!isChildQuestionValid)
            return;
        this.handleSaveCurrentChildQuestion();
        const newMaterial = {
            id: this.getRandomHash(),
            type: +type,
            isNewAdd: true,
            show: false,
            validResult: false,
            isEdit: false,
            errmsg: "您还未填写题干信息"
        };
        this.formData.materialList.push(newMaterial);
        this.updateContainerHeight();
        this.$nextTick(() => {
            this.mainContainerDom.scrollTop = this.mainContainerDom.scrollHeight - this.mainContainerDom.clientHeight;
            if (Object.keys(this.currentSelectedItem).length > 0) {
                this.childFormTaskQueue.push(() => {
                    this.handleShowChildQeustion(newMaterial);
                });
                this.currentSelectedItem.show = false;
            }
            else {
                this.handleShowChildQeustion(newMaterial);
            }
        });
    }
    // _move(e) {
    //   var t = e.relatedContext
    //     , n = e.draggedContext
    //     , r = t.element
    //     , i = n.element;
    //   return r && r.dragable && i.dragable
    // }
    getIconTop(idx) {
        const length = this.formData.materialList.length;
        return 0 === idx
            ? length > 1
                ? '-8px'
                : '12px'
            : 0 !== idx && idx === length - 1
                ? '-8px'
                : '-24px';
    }
    handleMove(mode, index) {
        if (this.disabled)
            return;
        const materialList = this.formData.materialList.slice();
        const newIndex = mode == 'down' ? index + 1 : index - 1;
        this.swapArr(materialList, index, newIndex);
        this.formData.materialList = materialList;
    }
    updateContainerHeight() {
        const containelEl = this.mainContainer;
        let height = 0;
        if (containelEl) {
            height = containelEl.clientHeight;
        }
        this.containerHeight = height;
    }
    handleShowChildQeustion(question) {
        // this.currentSelectedItem = {}
        this.currentSelectedItem = question;
        this.currentSelectedItem.show = true;
        this.childContainerDom.scrollTop = 0;
    }
    async handleEditChildQuestion(question) {
        if (this.hasLockChildQuestionClick)
            return;
        if (question.show)
            return;
        const isChildQuestionValid = await this.handleCheckCurrentChildQuestion();
        if (!isChildQuestionValid)
            return;
        const handler = () => {
            this.hasLockChildQuestionClick = true;
            this.updateContainerHeight();
            this.handleShowChildQeustion(question);
        };
        if (Object.keys(this.currentSelectedItem).length > 0) {
            this.handleSaveCurrentChildQuestion();
            this.childFormTaskQueue.push(handler);
            this.currentSelectedItem.show = false;
            return;
        }
        handler();
    }
    handleDeleteQuestion(index) {
        if (this.disabled)
            return;
        var question = this.formData.materialList[index];
        if (question.show)
            question.show = false;
        if (question.editParams && !question.isNewAdd) {
            this.formData.delete_list = [...(this.formData.delete_list || []), question.id];
        }
        this.formData.materialList.splice(index, 1);
        this.currentSelectedItem = {};
    }
    async formValidate(data) {
        if (this.formData.questionLibraryId === '') {
            this.$message.warning("请选择题库分类");
            return false;
        }
        if (!data.content || !data.describ) {
            this.$message.warning("您还未填写材料信息");
            return false;
        }
        if (data.materialList.length <= 0) {
            this.$message.warning("至少添加一道题目");
            return false;
        }
        const isChildQuestionValid = await this.handleCheckCurrentChildQuestion();
        if (!isChildQuestionValid) {
            return false;
        }
        this.handleSaveCurrentChildQuestion();
        this.currentSelectedItem.show = false;
        this.currentSelectedItem = {};
        return true;
    }
    formatFormData(data) {
        const result = {
            type: this.type,
            categoryId: data.questionLibraryId,
            content: data.content,
        };
        if (this.isEdit) {
            result.id = this.questionId;
        }
        result.subQuestionList = data.materialList.map(material => {
            if (material.isUpdate || material.isNewAdd) {
                return material.params;
            }
            else {
                const _params = {
                    type: material.type,
                    content: material.editParams.content,
                    // simpleContent: material.editParams.describ,
                    analysis: material.editParams.analysis,
                };
                if (2 === material.type) {
                    return {
                        ..._params,
                        optionList: [{
                                content: material.editParams.answer
                            }]
                    };
                }
                if (3 === material.type) {
                    return {
                        ..._params,
                        optionList: [{
                                correct: material.editParams.answer
                            }]
                    };
                }
                if (4 === material.type) {
                    return {
                        ..._params,
                        optionList: material.editParams.answer.map(ans => ({
                            content: ans
                        })),
                        disorderMatch: material.editParams.disorderMatch ? 1 : 0
                    };
                }
                return {
                    ..._params,
                    optionList: material.editParams.optionList.map(opt => ({
                        content: opt.content,
                        correct: opt.type
                    }))
                };
            }
        });
        // var t = [0, 1, 5];
        // if (this.isEdit) {
        //   data.add_list = this.formData.materialList.filter(e => e.isNewAdd).map(e => {
        //     e.sort;
        //     var n = e.params
        //       , r: any = {}
        //       , i = n.type;
        //     return r.type = i,
        //       r.analysis = n.analysis,
        //       r.content = n.questionContent,
        //       r.describ = n.questionDescrib,
        //       r.audio_urls = n.audio_urls || [],
        //       r.weight = e.weight,
        //       t.includes(i) 
        //       ? r.options = (n.OptionList || []).map(e => {
        //         var t = {};
        //         t.content = e.optionContent
        //           t.describ = e.optionDescrib
        //           t.answer_type = e.answerType
        //         return t
        //       }) : (
        //         r.correct_answer = n.correctAnswer,
        //         4 === i && (r.disorder_match = n.disorder_match)
        //       ),
        //       r
        //   })
        //   data.update_list = this.formData.materialList.filter(e => e.isUpdate).map(e => {
        //     var t = Object(o["a"])(Object(o["a"])({}, e.params || {}), {}, {
        //       questionId: e.id
        //     });
        //     delete t.question_library_id
        //     return t
        //   })
        //   data.update_weight_map = this.updateWeightMap
        //   delete data.question_list
        // } else {
        //   data.question_list = data.question_list.reduce((function (e, n) {
        //     var r = n.params
        //       , i = r.type
        //       , o = {
        //         type: i,
        //         content: r.questionContent,
        //         describ: r.questionDescrib,
        //         analysis: r.analysis,
        //         audio_urls: r.audio_urls || [],
        //         weight: n.weight
        //       };
        //     if (t.includes(i)) {
        //       var a = r.OptionList;
        //       o.options = [],
        //         a.forEach((function (e, t) {
        //           var n = o.options[t] = {};
        //           n.content = e.optionContent,
        //             n.describ = e.optionDescrib,
        //             n.answer_type = e.answerType
        //         }
        //         ))
        //     } else
        //       o.correct_answer = r.correctAnswer,
        //         4 === i && (o.disorder_match = r.disorder_match);
        //     return e.push(o),
        //       e
        //   }
        //   ), [])
        // }
        return result;
    }
    async handleSubmit(redirect) {
        const isFormValid = await this.formValidate(this.formData);
        if (!isFormValid)
            return;
        const data = this.formatFormData(JSON.parse(JSON.stringify(this.formData)));
        this.hasSubmit = true;
        try {
            await saveQuestionDetail(data);
            this.$message.success('保存成功');
            this.shouldDialogShow = false;
            if (this.paperId || this.$route.query.step) {
                // t.gooseClass && Object(v["a"])("saveQuestionSuccess", {
                //   loading: false
                // })
                this.$bus.$emit("edit-question-of-paper-success", this.questionId);
            }
            else {
                setTimeout(() => {
                    redirect && this.$router.replace({
                        name: "Question"
                    });
                }, 800);
            }
        }
        catch (_) { }
        finally {
            this.hasSubmit = false;
        }
    }
    handleCancel() {
        this.$router.go(-1);
        // this.gooseClass && Object(v["a"])("goSecondStep", {})
    }
    async handleCheckCurrentChildQuestion() {
        const formEl = this.questionForm;
        if (!formEl)
            return true;
        this.loading = true;
        await this.sleep(1000);
        this.loading = false;
        const isFormValid = formEl.validForm();
        const errorMsg = formEl.errmsg || '';
        this.currentSelectedItem.validResult = isFormValid;
        this.currentSelectedItem.errmsg = errorMsg;
        if (isFormValid)
            return true;
        // this.$message.error(errorMsg)
        return false;
    }
    handleSaveCurrentChildQuestion() {
        const formEl = this.questionForm;
        const hasSelected = Object.keys(this.currentSelectedItem).length > 0;
        const type = this.currentSelectedItem.type;
        if (formEl && hasSelected) {
            // if (type === 4) {
            //   formEl.fillInFinalyData()
            // }
            this.currentSelectedItem.params = JSON.parse(JSON.stringify(formEl.getParams()));
            const params = {
                content: formEl.questionContent,
                describ: formEl.questionDescribe,
                analysis: formEl.analysisContent,
            };
            if (type === 0 || type === 1 || type === 5) {
                params.optionList = !formEl.isEdit ? formEl.optionList : [...formEl.oldOptionList, ...formEl.newOptionList];
                params.optionList.forEach((opt, index) => {
                    opt.type = formEl.checkStatus[index] ? 1 : 0;
                });
            }
            else if (type === 2) {
                params.answer = formEl.answerContent;
            }
            else if (type === 3) {
                params.answer = formEl.judgeTrue ? 1 : 0;
            }
            if (type === 4) {
                params.answer = formEl.fillInAnswerArr;
                params.disorderMatch = formEl.disorderMatch;
            }
            const question = JSON.parse(JSON.stringify(params));
            if (!this.currentSelectedItem.editParams) {
                this.currentSelectedItem.editParams = {};
            }
            const editParams = this.currentSelectedItem.editParams;
            ['analysis', 'content', 'describ', 'answer', 'disorderMatch', 'optionList'].forEach(key => {
                if (question[key] != null) {
                    editParams[key] = question[key];
                }
            });
            this.currentSelectedItem.isUpdate = true;
        }
    }
    handleChildQuestContentChange(content, describ) {
        const id = this.currentSelectedItem.id;
        this.$set(this.contentMap, id, this.insulateImg(content, describ));
    }
    onQuestionFormDestroyed() {
        const handler = this.childFormTaskQueue.shift();
        setTimeout(() => {
            handler && handler();
        });
    }
    getChildQuestionContent(title, html) {
        return `<div style="display: inline-block">${title}</div>${html}`;
    }
    insulateImg(content, describ) {
        // if (!content || !describ)
        //   return '';
        // var r = /<img\b[^>]*src[=\"\'\s]+[^\.]*\/([^\.]+)\.[^\"\']+[\"\']?[^>]*>/g
        //   // , i = /<iframe(.*?)class="xiaoe-iframe-audio"(.*?)>/g
        //   // , o = /<iframe(.*?)class="xiaoe-iframe-video"(.*?)>/g
        //   , a = n("7cf2")
        //   , s = n("e497")
        //   , l = n("b038")
        //   , c = describ.replace(r, '<img class="icon-img" src="'.concat(a, '" />')).replace(i, '<img src="'.concat(l, '" />')).replace(o, '<img src="'.concat(s, '" />'));
        // return c
        return describ.replace(/<img\b[^>]*src[=\"\'\s]+[^\.]*\/([^\.]+)\.[^\"\']+[\"\']?[^>]*>/g, `<img class="icon-img" src="${this.imgIcon}" />`);
    }
    async handleGetQuesLibInfo() {
        if (!this.isEdit || !this.questionId)
            return;
        this.loading = true;
        try {
            const res = await getQuestionDetail(this.questionId);
            const data = res.data.data;
            this.topicTypeName = data.categoryName;
            this.formData.questionLibraryId = data.categoryId;
            this.questionBankParentId = data.categoryParentId || '0';
            this.initData(data);
        }
        catch (error) {
            this.topicTypeName = '默认分类';
            this.formData.questionLibraryId = '1';
            this.questionBankParentId = '0';
        }
        finally {
            this.loading = false;
        }
    }
    async handleCheckedClasses(nodeData) {
        const questionBankId = nodeData.id;
        const topicTypeName = nodeData.name;
        const questionBankParentId = nodeData.parentId;
        if (!this.isEdit) {
            this.topicTypeName = topicTypeName;
            this.formData.questionLibraryId = questionBankId;
            this.showDialog = false;
            return;
        }
        const oldQuestionBankId = this.formData.questionLibraryId;
        this.formData.questionLibraryId = questionBankId;
        try {
            await transferQuestion([this.questionId], questionBankId);
            this.$message.success("题目转移成功！");
            this.topicTypeName = topicTypeName;
            this.questionBankParentId = questionBankParentId;
            this.showDialog = false;
        }
        catch (error) {
            this.formData.questionLibraryId = oldQuestionBankId;
        }
    }
    handleSelect() {
        this.showDialog = true;
    }
};
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], MaterialQuestionEdit.prototype, "interceptRoute", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "container", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "header", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "formWrapper", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "mainContainer", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "questionList", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "childContainer", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "material", void 0);
tslib_1.__decorate([
    Ref()
], MaterialQuestionEdit.prototype, "questionForm", void 0);
tslib_1.__decorate([
    Watch('formData.materialList', { deep: true })
], MaterialQuestionEdit.prototype, "handleMaterialListChange", null);
tslib_1.__decorate([
    Watch('disabled', { immediate: true })
], MaterialQuestionEdit.prototype, "handleDisabledChange", null);
MaterialQuestionEdit = tslib_1.__decorate([
    Component({
        name: 'MaterialQuestionEdit',
        components: {
            Editor: UEditor,
            QuestionForm,
            TransferDialog,
            LocalTopTips,
            SelectClassify
        },
    })
], MaterialQuestionEdit);
export default MaterialQuestionEdit;
